import { InjectionToken } from '@angular/core';
import { AppConfig } from './models/config/app-config';

export const APP_CONFIG = new InjectionToken<AppConfig>('app.config');

export const REST_BASE_URL = '../../api';
export const ACTUATOR_INFO_URL = '../../actuator/info';
export const REST_BIOMETRIE_URL = REST_BASE_URL + '/visa/biometrie';
